
    const data = {"name":"src/core/icons/swap-vertical-circle","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2M6.5 9 10 5.5 13.5 9H11v4H9V9H6.5m11 6L14 18.5 10.5 15H13v-4h2v4h2.5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            